<script setup>
import { DrawerRoot } from "vaul-vue";
import { useForwardPropsEmits } from "reka-ui";

const props = defineProps({
  open: { type: Boolean, default: undefined },
  shouldScaleBackground: { type: Boolean, default: true },
  direction: { type: String, default: undefined },
  dismissible: { type: Boolean, default: undefined },
  snapPoints: { type: Array, default: undefined },
  activeSnapPoint: { type: [Number, String], default: undefined },
  modal: { type: Boolean, default: true },
  nested: { type: Boolean, default: undefined },
  handleOnly: { type: Boolean, default: true },
});

const emits = defineEmits(["update:open", "update:activeSnapPoint"]);

const forwarded = useForwardPropsEmits(props, emits);
</script>

<template>
  <DrawerRoot v-slot="slotProps" data-slot="drawer" v-bind="forwarded">
    <slot v-bind="slotProps" />
  </DrawerRoot>
</template>
